
import PopupMessage from '@/components/store/PopupMessage'
import GlobalSearch from '@/components/store/GlobalSearch'
import GlobalSearchMobile from '@/components/store/mobile/GlobalSearchMobile'
import PopupMessageShipping from '@/components/store/PopupMessageShipping'
import SnackbarCart from '@/components/store/SnackbarCart'
import MenuMobile from '@/components/store/mobile/MenuMobile'
import BannerTopMobile from '@/components/store/mobile/BannerTopMobile'

const GlobalComponents = {
  install(Vue) {
    Vue.component('BannerTopMobile', BannerTopMobile);
    Vue.component('MenuMobile', MenuMobile);
    Vue.component('PopupMessage', PopupMessage);
    Vue.component('GlobalSearch', GlobalSearch);
    Vue.component('GlobalSearchMobile', GlobalSearchMobile);
    Vue.component('SnackbarCart', SnackbarCart);
    Vue.component('PopupMessageShipping', PopupMessageShipping);
  }
}

export default GlobalComponents
